// ** 全局 i18n 运行时补丁
// react-select 默认使用 option.label 直接渲染下拉选项，这里把默认 getOptionLabel
// 替换为经 L() 翻译的版本，使后端返回的枚举/下拉标签也能随语言切换。
import L from './L'

try {
  const Select = require('react-select').default || require('react-select')
  if (Select && Select.defaultProps) {
    Select.defaultProps = {
      ...Select.defaultProps,
      getOptionLabel: (option) => {
        if (option === null || option === undefined) return ''
        const label = option.label === null || option.label === undefined ? option : option.label
        return L(label)
      }
    }
  }
} catch (e) {
  // 补丁失败不影响主流程（仅下拉标签保持原文）
  console.warn('react-select i18n patch skipped:', e && e.message)
}
